/*
* @Author: babysoft08
* @Date:   2025-06-07 21:55:41
* @Last Modified by:   babysoft08
* @Last Modified time: 2025-06-08 16:22:03
*/
import axios from 'axios';
import {API_URL, QC_API_URL} from '../../constants.js';

class QualityControlService {
	async saveData(data) {
		const url = `${QC_API_URL}/save-qc-data/`;
		const headers = {
			'Content-Type':'multipart/form-data',
			'Access-Control-Allow-Origin':'*'
		}
		let formData = new FormData();
		
		// Append text fields
		for (let key in data) {
			if (key !== 'files') {
				formData.append(key, data[key]);
			}
		}

		// Append files
		if (data.files && data.files.length > 0) {
			data.files.forEach((file, index) => {
				formData.append('files', file); // use same key name "files" for all
			});
		}
		return axios({
			url:url,
			method: 'post',
			crossDomain:true,
			data: formData,
			config:{headers:headers},
			//headers: {'Access-Control-Allow-Origin': '*'}
		}).then(function(response) {
			return response;
		}).catch(function(response) {
			return response;
		});
	}

	async checkStatus(data) {
		const url = `${QC_API_URL}/check-qc-status/`;
		const headers = {
			'Content-Type':'application/json',
			'Access-Control-Allow-Origin':'*'
		}
		return axios({
			url:url,
			method: 'post',
			crossDomain:true,
			data: JSON.stringify(data),
			config:{headers:headers},
			//headers: {'Access-Control-Allow-Origin': '*'}
		}).then(function(response) {
			return response;
		}).catch(function(response) {
			return response;
		});


	}
}

export default QualityControlService;